/*
 * mc-events.js - Merch Control conversion event layer.
 *
 * WHAT THIS IS: the site half of conversion tracking. It emits events for the three
 * things that count as a lead on this site - a quote form submission, a contact form
 * submission, and a click on a phone or email link.
 *
 * WHAT IT IS NOT: an analytics install. There is no GA4 or GTM on this store yet.
 * Every event below is pushed to window.dataLayer and passed to gtag() if either is
 * present, and is a silent no-op if neither is. So this is ready and inert: the moment
 * a GA4 measurement ID or a GTM container is connected, the events start flowing with
 * no further theme work.
 *
 * Connecting GA4/Ads and marking these as conversions sits with Kobi (paid media and
 * conversion tracking), not in the theme.
 *
 * Event names follow GA4 conventions:
 *   generate_lead  - form submitted successfully (params: method)
 *   contact_click  - phone or email link clicked (params: method, link_url)
 *
 * NOTE: as at 23/08/2026 there is no phone number published anywhere on the site, so
 * the tel: branch cannot fire yet. It is wired so it works the day one is added.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function track(name, params) {
    var payload = Object.assign({ event: name }, params || {});
    try {
      window.dataLayer.push(payload);
    } catch (e) {
      /* dataLayer unavailable - nothing to do */
    }
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', name, params || {});
      } catch (e) {
        /* gtag threw - never let tracking break the page */
      }
    }
  }

  // Exposed so the Liquid success branches can fire a lead event on the server-rendered
  // "thanks" state, which is far more reliable than trying to intercept the submit.
  window.mcTrack = track;

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('tel:') === 0) {
        track('contact_click', { method: 'phone', link_url: href });
      } else if (href.indexOf('mailto:') === 0) {
        track('contact_click', { method: 'email', link_url: href });
      }
    },
    true
  );
})();
